/**
 * EDITOR-ONLY visual cue for the Nav Menu widget's "Overflow Menu" toggle
 * (gwschild/inc/elementor-nav-menu-overflow.php) — the actual collapse
 * behavior only makes sense to verify on the real, full-width live page,
 * not the editor's own cramped preview canvas, so this doesn't attempt
 * to simulate it there. It just confirms "this is on" so it's obvious at
 * a glance while editing, same accepted-limitation pattern as this
 * project's other editor-preview fidelity gaps (Slider, YouTube Feed).
 *
 * Hooks Elementor's own `nav-menu` widget type directly (not a custom
 * GWS widget), so this is enqueued unconditionally via `wp_enqueue_scripts`
 * (matching gparent's own overflow-menu-frontend.js) rather than through
 * any widget's own get_script_depends() — early-returns immediately
 * outside the editor, so it's inert on the live frontend.
 */
( function () {
	'use strict';

	function registerElementReadyHook() {
		window.elementorFrontend.hooks.addAction( 'frontend/element_ready/nav-menu.default', function ( $scope ) {
			if ( ! window.elementorFrontend.isEditMode || ! window.elementorFrontend.isEditMode() ) {
				return;
			}

			var tagged = $scope[ 0 ].querySelector( '[data-gws-overflow-menu="1"]' );

			if ( ! tagged ) {
				return;
			}

			tagged.style.outline = '2px dashed #7b61ff';
			tagged.style.outlineOffset = '2px';
			tagged.setAttribute(
				'title',
				'GWS Overflow Menu is enabled — the actual collapsing only runs on the live page, not in this editor preview.'
			);
		} );
	}

	if ( window.elementorFrontend && window.elementorFrontend.hooks ) {
		registerElementReadyHook();
	} else {
		window.addEventListener( 'elementor/frontend/init', registerElementReadyHook );
	}
} )();
